<template>
  <div>
    <v-dialog
      v-model="isActive"
      :width="getModalWidth"
      class="pf-global-modal pf-intro-dialog"
      persistent
      :full-width="fullWidth"
    >
      <slot name="modal-content">
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Parentfinder Modal
          </v-card-title>

          <v-card-text>
            Parentfinder app modal content goes here!
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="closeModal"
            >
              Close Me
            </v-btn>
          </v-card-actions>
        </v-card>
      </slot>
    </v-dialog>
  </div>
</template>
<script>

/* global session */
import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);
export default {
  name: 'app-modal',
  components: {
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '60%'
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    session: session,
    isActive: false
  }),
  computed: {
    getModalWidth () {
      return this.$vuetify.breakpoint.smAndUp ? this.width : '100%';
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.isActive = this.active;
    window.getApp.$on('ChangeAppModalStatus', (status) => {
      this.isActive = status;
    });
  },
  methods: {
    closeModal () {
      this.isActive = false;
    }
  }
};
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppModal.vue